// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import { ModuleHeader } from '../../../../../../layout/elements/ModuleHeader';
import { Col } from '../../../../../../layout/elements/Col';

// View
import { Container } from './MotorControl.style';
import { MotorControlProps } from './MotorControl.types';

function MotorControl({
  className,
  onOpenDrawer,
  testId,
}: MotorControlProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  return (
    <Container
      data-testid={testId}
      className={className}
    >
      <Col>
        <ModuleHeader
          onClick={onOpenDrawer}
          title={t('view.crusher.motorControl.title')}
          testId={`${testId}-module-header`}
        />
      </Col>
    </Container>
  );
}

export { MotorControl };
